/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.analytics.rpc.LeadGenerationRpc
 */

import type {
  ChirpAvroRpcDetails,
  Requestify,
  unhandledEnumCase,
  Default,
  HubspotMetadata,
} from 'rpc-client-utils';

/**
 * Record for com.hubspot.chirp.core.CausalChainLink
 */
export type CausalChainLink = {
  coordinates: ChirpMethodCoordinates;
  errorClass: string;
  errorMessage?: string;
};

/**
 * Record for com.hubspot.chirp.core.ChirpMethodCoordinates
 */
export type ChirpMethodCoordinates = { service: string; method: string };

export type EmptyError = {
  chirpErrorMessage?: string;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry?: boolean;
};

/**
 *  This class can be used as a response type in cases where no response is needed or
 *  where <code>void</code> might have been used in a REST-ful context.
 */
export type ChirpVoid = {};

export type ContactLeadAction =
  | 'CLICKED_IMAGE'
  | 'CLICKED_VIDEO'
  | 'CLICKED_INSTALL'
  | 'CLICKED_SETUP_GUIDE'
  | 'CLICKED_COMPANY_WEBSITE'
  | 'CLICKED_REQUEST_CONTACT'
  | 'CLICKED_SCHEDULE_MEETING'
  | unhandledEnumCase;

export type CreateLeadContactRequest = {
  listingId: number;
  action: ContactLeadAction;
};

export type CreateLeadContactRequestType = Requestify<CreateLeadContactRequest>;
export type CreateLeadContactResponseType = ChirpVoid;
export type CreateLeadContactErrorType = EmptyError & HubspotMetadata;
export const createLeadContactRpc: ChirpAvroRpcDetails<
  CreateLeadContactRequestType,
  CreateLeadContactResponseType,
  CreateLeadContactErrorType,
  false
> = {
  serviceName: 'com.hubspot.marketplace.analytics.rpc.LeadGenerationRpc',
  rpcName: 'createLeadContact',
  auth: 'app',
  fingerprint: 'bfW_RWRddn-OUe2e_r4XmZwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};
